import * as React from 'react';

const PoliticSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="politic_svg__eds-icon--politic_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="politic_svg__eds-icon--politic_base"
            fill="#231F20"
            d="M15 7V4H7V2H6v19H5v1h3v-1H7v-8h7v3h6V7h-5zm-1 5H7V9h7v3zm0-4H7V5h7v3zm5 7h-4v-3h4v3zm0-4h-4V8h4v3z"
        />
    </svg>
);

PoliticSvg.displayName = 'PoliticSvg';
export default PoliticSvg;
